export const workOrderStatusOptions = [
    "Queue",
    "Active",
    "Parked",
    "Reporting",
    "Report Assist",
    "Hold",
    "Ready for Pickup",
    "Completed"
] as const;

export type WorkOrderOperationalStatus = (typeof workOrderStatusOptions)[number];
export type WorkOrderAssignmentStatus = "Assigned" | "Unassigned";

export interface WorkOrderStatusHistoryEntry {
    id: number;
    status: WorkOrderOperationalStatus;
    userId: string;
    userName: string;
    holdReason?: string;
    acceptedQuantity?: string | number;
    rejectedQuantity?: string | number;
    reportNotes?: string;
    inspectorInitials?: string;
    createdAt: string;
}

export type WorkOrder = {
    id: number,
    labNumberDate: string, 
    creatorName: string,
    creatorId: string,
    receivedByName: string,
    receivedById: string,
    createdAt: string, 
    updaterId: string,
    updaterName: string, 
    updatedAt: string,
    contactName: string
    contactId: string,
    organizationId: string,
    organizationName: string,
    partsReceivedDate: string,
    workOrderStatus: WorkOrderOperationalStatus,
    workOrderDate: string,
    deadline: string,
    labNumber: string,
    customer: string,
    requestor: string, 
    requestorName: string, 
    poNumber: string, 
    quoteNumber: string, 
    techs: {value: string, label: string}[], 
    paid: string, 
    infoData: InfoDataEntry[],
    statusData: Record<string, Record<string, StatusEntry>>,
    void: "yes" | "no" | "all",
    voidReason: string,
    validateReason: string, 
    holdReason: string,
    acceptedQuantity?: string | number,
    rejectedQuantity?: string | number,
    reportNotes?: string,
    inspectorInitials?: string,
    notes: string, 
    reqId: string, 
    pdfId: string,
    workOrderFiles: FileItem[],
    workOrderStatusHistory: WorkOrderStatusHistoryEntry[],
}

export interface SelectOption {
    value: string | null;
    label: string | null;
}

export interface StatusEntry {
    proc?: string;
    qty?: string | number;
    eta?: string | number;
    duration?: string | number;
    start?: boolean;
    startTime: string;
    complete?: boolean;
    completeTime?: string;
    notes?: string;
    initial?: string;
    userId?: string;
    optionalInspectors?: string[];
}

export interface InfoDataEntry {
    label: string;
    optgroup: string;
    pn?: string;
    qty?: string | number;
    proc?: string;
    criteria?: string;
    tech?: string;
}

export interface ProcEntry {
    proc: string;
    spec: string[];
    date?: string;
}

export interface ProcCategory {
    category: string;
    data: ProcEntry[];
}

export interface Settings {
    proc: ProcCategory[];
}

export interface WorkOrderRouteData {
    settings: Settings;
    workOrder: WorkOrder;
}

export interface WorkOrderFormProps {
    keyword: "Add" | "Edit";
}

export interface TaskTech {
    id: string;
    name: string;
}

export interface TaskWorkOrder extends Pick<WorkOrder, "id" | "labNumber" | "organizationName" | "workOrderStatus"> {
    techs: TaskTech[];
}

export const assignmentText = (
    techs?: Array<{ value?: string | null; label?: string | null } | { id?: string | null; name?: string | null }>
): WorkOrderAssignmentStatus => (techs?.length ? "Assigned" : "Unassigned");

export type FileItem = {
    id: string;
    name: string;
    type: string;
};

export type ContextMenuState = {
    show: boolean;
    top?: number;
    left?: number;
    workOrderFiles?: FileItem[];
};

export type ContextMenuProps = ContextMenuState & {
    selected: number[];
    setSelected: (s: number[]) => void;
    setContextMenu: (s: ContextMenuState) => void;
    id: number;
};
